import AbstractApiService from 'src/services/abstractApiService';
import { DOC2API_URL } from 'pages/APIs';
import { api } from 'pages/APIs';
import axios from 'axios';

export default class SupplierApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async supplier_dashboard(data: any): Promise<any> {
    const querystring = this.encodeQueryData(data);
    return super.get(
      DOC2API_URL +
        '/org_details/get_organisation_suppliers' +
        '?' +
        querystring,
      {},
    );
  }
  public async get_supplier_expiration_count_dashboard(): Promise<any> {
    return super.get(
      DOC2API_URL + '/org_details/get_organisation_suppliers_expiration_count',
    );
  }
  public async getSupplierLayout(): Promise<any> {
    return super.get(api.get_supplier_layout_document_type);
  }
  public async createLayoutSupplier(data: any): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }
    return super.post(api.create_supplier_layout_document_type, formData);
  }
  public async getSupplierLayoutBYID(id: any, data: any): Promise<any> {
    const querystring = this.encodeQueryData(data);
    const url = api.get_suppier_layout_form + id + (querystring ? '?' + querystring : '');
    return super.get(url);
  }
  public async getSupplierLayoutBYIDforBuilder(id: any): Promise<any> {
    return super.get(api.get_suppier_layout_form + id);
  }
  public async getDefaultTemplate(id: any): Promise<any> {
    const formData = new FormData();
    return super.put(api.use_default_layout + id, formData);
  }
  public async createSupplierLayoutForm(data: any): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }
    return super.post(api.submit_supplier_form, formData);
  }
  public async getLogo(key: string): Promise<any> {
    return super.get(`${api.get_preference}?key=${key}`);
  }
  public async getPublicLogo(org_id: string): Promise<any> {
    return axios.get(`${api.get_organisation_logo}?org_id=${org_id}`);
  }
}
